import {createFilterOptions} from "@mui/material";

const shorten = (str) => {
    if (!str) return '';
    return str[0].toUpperCase() + '.';
}

export const renderName = (item) => {
    return item ?
        `${item?.lastName || ''}${item?.firstName ? `, ${item?.firstName}` : ''}${item?.middleName ? ` ${shorten(item?.middleName)}` : ''}` :
        'N/A';
};

/** Payer label for the UI. Falls back to the sync name for payers created before display names existed. */
export const renderPayerName = (payer) => {
    return payer?.displayName || payer?.name || '';
};

const stringifyPatient = (option) => {
    const noComma = `${option?.lastName || ""} ${option?.firstName || ""} ${option?.middleName || ""}`;
    const withComma = `${option?.lastName || ""}${
        option?.firstName ? `, ${option.firstName}` : ""
    }${option?.middleName ? ` ${shorten(option.middleName)}` : ""}`;
    return `${noComma} ${withComma}`.trim();
};

export const patientFilter = (options, { inputValue }) => {
    const terms = inputValue.toLowerCase().split(/\s|,/).filter(Boolean);

    return options.filter((opt) => {
        const haystack = stringifyPatient(opt).toLowerCase();
        return terms.every((t) => haystack.includes(t));
    });
};